import React from "react";
import {
  Menu,
} from "semantic-ui-react";
import { useSelector } from "react-redux";
import './Explorerbar.css'
import { getMenuEnabled } from "../../features/tableData/visualSlice";
import Homebar from "./Homebar";
import Databar from "./Databar";
import Examplesbar from "./Examplesbar";

const Explorerbar = () => {
  const menuEnabled = useSelector(getMenuEnabled);

  return (
          <Menu vertical fluid className="explorer">
            {menuEnabled === "home" && <Homebar/>}
            {menuEnabled === "database" && <Databar/>}
            {menuEnabled === "examples" && <Examplesbar/>}
          </Menu>
  );
};

export default Explorerbar;